import React, { useState } from 'react';
import { Table, TableBody, Box, Grid } from '@mui/material';
import SectionHeader from './SectionHeader';
import AccountStatusRow from './AccountStatusRow';
import TableColumnHeaders from './TableColumnHeaders';
import {
  UserAccountsTableData,
  ACTIVE_SUB_ROWS,
  ACTIVE_SUB_ROWS_HEADER,
  UserAccountSection,
} from '../../../data/report/helpers/userAccountsUtils';

interface SectionedTableViewProps {
  sections: UserAccountSection[];
  columns: string[];
  data: UserAccountsTableData;
}

const SectionedTableView: React.FC<SectionedTableViewProps> = ({ sections, columns, data }) => {
  const [expandedRow, setExpandedRow] = useState<string | null>(null);

  const toggleExpand = (rowKey: string) => {
    setExpandedRow(prev => (prev === rowKey ? null : rowKey));
  };

  return (
    <>
      {sections.map((section, sectionIndex) => {
        const isTopSection = sectionIndex === 0;

        return (
          <Grid mb={3} key={section.label}>
            <Box sx={{ minWidth: '850px' }}>
              {isTopSection ? (
                <Box sx={{ display: 'grid' }}>
                  <Box
                    sx={{
                      gridArea: '1/1',
                      zIndex: 1,
                      width: 'fit-content',
                    }}>
                    <SectionHeader
                      count={section.count}
                      label={section.label}
                      helpContent={section.helpContent}
                      countVariant={section.countVariant}
                    />
                  </Box>
                  <Box
                    sx={{
                      gridArea: '1/1',
                      zIndex: 0,
                      display: 'flex',
                      alignItems: 'flex-end',
                    }}>
                    <Table>
                      <TableColumnHeaders columns={columns} />
                    </Table>
                  </Box>
                </Box>
              ) : (
                <SectionHeader
                  count={section.count}
                  label={section.label}
                  helpContent={section.helpContent}
                  countVariant={section.countVariant}
                />
              )}

              <Table>
                <TableBody>
                  <Box
                    sx={{
                      borderRadius: 0,
                      overflow: 'visible',
                      mt: 1,
                    }}>
                    {section.rows.map(rowKey => {
                      const isExpanded = expandedRow === rowKey;

                      return (
                        <Box key={rowKey} sx={{ mb: 1 }}>
                          <AccountStatusRow
                            rowKey={rowKey}
                            columns={columns}
                            data={data}
                            subRows={rowKey === 'activeUserCount' ? ACTIVE_SUB_ROWS : undefined}
                            subRowHeader={
                              rowKey === 'activeUserCount' ? ACTIVE_SUB_ROWS_HEADER : undefined
                            }
                            isExpanded={isExpanded}
                            onToggleExpand={() => toggleExpand(rowKey)}
                          />
                        </Box>
                      );
                    })}
                  </Box>
                </TableBody>
              </Table>
            </Box>
          </Grid>
        );
      })}
    </>
  );
};

export default SectionedTableView;
